import styled from 'styled-components';
import { desktop } from '../../utils/constants';

export const ProjectSummaryContainer = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  color: #333;
  font-size: 2.4rem;
  & .loading {
    display: none;
  }
  @media all and (min-width: ${desktop}) {
    max-width: 30%;
    flex: 1 0 30%;
  }
`;

export const SummaryCard = styled.div`
  border-radius: 0.1rem;
  margin-bottom: 2rem;
  min-height: 7.5rem;
  background-color: #fff;
  padding: 20px;
`;

export const Divider = styled.hr`
  color: #cccccb;
  margin: 20px 0;
`;

export const Footer = styled.div`
  font-size: 12px;
  margin-top: 20px;
  a {
    text-decoration: underline;
  }
  button {
    margin-bottom: 20px;
  }
  @media all and (max-width: ${desktop}) {
    display: none;
  }

`;

export const LinkButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-decoration: underline;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
`;

export const DisclaimerText = styled.div`
  font-size: 12px;
  margin-bottom: 20px;
`;